<template>
  <div class="infoContainer">
    <TenantAuth
      ref="TenantAuth"
      @submitDialog="$store.dispatch('updateSession')"
    />
    <CreateOrEditStaff ref="CreateOrEditStaff" />

    <div v-if="$store.state.session.tenant" class="companyInfo">
      <div style="display: flex; align-items: center">
        <div
          class="one_lines"
          style="
            font-weight: bold;
            font-size: 15px;
            color: #545454;
            width: 280px;
          "
        >
          {{ $store.state.session.tenant.name }}
        </div>
      </div>
      <div style="display: flex; align-items: center">
        <div style="margin-right: 10px">{{ l("信用状态") }} :</div>
        {{
          $utils.listFilter(
            $store.state.basicInfo.credit_ratingList,
            $store.state.session.tenant.credit_rating
          )
        }}
      </div>

      <div style="font-size: 12px">
        <div class="ViewLink" @click="clickTenant">
          {{ l("查看认证信息") }}
        </div>
        <div
          v-if="$store.getters.checkPermission('staff.add')"
          class="ViewLink"
          style="margin-left: 20px"
          @click="inviteStaff"
        >
          {{ l("邀请子账号") }}
        </div>
      </div>
    </div>

    <div class="managerInfo">
      <div
        style="
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 10px 0;
          box-sizing: border-box;
        "
      >
        <div class="label">
          {{ l("专属业务员") }}
        </div>

        <div>
          联系人：{{
            $store.state.session.user[main_manager_type].display_name
          }}
        </div>
        <div>
          手机号：{{ $store.state.session.user[main_manager_type].mobile }}
        </div>
      </div>
      <el-image
        :src="$store.state.session.user[main_manager_type].avatar"
        fit="cover"
        style="width: 108px; height: 108px; margin-left: 30px"
      >
      </el-image>
    </div>
  </div>
</template>

<script>
import TenantAuth from "./operation/TenantAuth.vue";
import CreateOrEditStaff from "@/views/staff/operation/CreateOrEditStaff.vue";

export default {
  name: "TenantManagerInfo",
  components: {
    TenantAuth,
    CreateOrEditStaff,
  },
  data() {
    return {};
  },
  computed: {
    main_manager_type() {
      const manager_role_id =
        this.$store.state.session.user.pre_business_tag.extra_params
          .manager_role_id;
      let return_type;
      if (manager_role_id == 3004) {
        return_type = "manager_shichang";
      } else if (manager_role_id == 3005) {
        return_type = "manager_caigou";
      }
      return return_type;
    },
  },
  mounted() {},
  methods: {
    clickTenant() {
      this.$refs.TenantAuth.Type = "View";
      this.$refs.TenantAuth.Show(this.$store.state.session.tenant);
    },
    inviteStaff() {
      this.$refs.CreateOrEditStaff.Type = "Create";
      this.$refs.CreateOrEditStaff.Show();
    },
  },
};
</script>

<style scoped lang="scss">
.infoContainer {
  height: 168px;
  box-sizing: border-box;
  padding: 30px 40px;
  display: flex;
  justify-content: space-evenly;
  background: #fff;
  flex-grow: 1;
  .companyInfo {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    font-size: 14px;
    box-sizing: border-box;
    padding: 10px 0;
  }
  .managerInfo {
    width: 332px;
    height: 108px;
    box-sizing: border-box;
    //background: $warningPlainColor;
    //border: 1px solid $warningColor;
    box-sizing: border-box;
    //border-radius: 6px;
    position: relative;
    display: flex;
    align-items: center;
    flex-shrink: 0;

    .label {
      font-size: 15px;
      font-weight: bold;
      border-top-right-radius: 6px;
      border-bottom-left-radius: 10px;
    }
  }
}
</style>

